export default __webpack_public_path__ + "static/media/Quality_partnerships.7e867757.webp";